import React from "react";
import { NavLinks } from "../WalletSection/NavLinks";
import { StartTradingButton } from "../StartTradingButton/StartTradingButton";
import { ReactComponent as NavbarTogglerIcon } from "../../../img/navbar-toggler.svg";
import { useIsDesktop, useIsMobile } from "hooks/useDeviceType";
import { withIsVisible } from "utils/reactUtils";

interface NavbarProps {
  setIsSideNavOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Navbar = ({ setIsSideNavOpen }: NavbarProps) => {
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();

  const SideNavSandwich = withIsVisible(() => {
    return (
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
        onClick={() => {
          setIsSideNavOpen(true);
        }}
      >
        <NavbarTogglerIcon />
      </button>
    );
  });

  return (
    <>
      <NavLinks isVisible={isDesktop} />
      <StartTradingButton isVisible={!isMobile} />
      <SideNavSandwich isVisible={!isDesktop} />
    </>
  );
};
